import { has, union, uniq } from 'lodash';

export function getDefaultMetaReducers(ACTIONS)
{
    return {
        [ACTIONS.LOADING]: (state, payload) =>
        {
            const defaultEntity = getDefaultMetaEntity(state, payload.id);
            defaultEntity.loading = payload.status;
            defaultEntity.id = payload.id;

            if (payload.status)
            {
                defaultEntity.error = '';
                defaultEntity.includes = payload.includes || null;
            }
            else
            {
                defaultEntity.includes = null;
            }

            return {
                ...state,
                ...{
                    [payload.id]: defaultEntity,
                },
            };
        },

        [ACTIONS.NEED_UPDATE]: (state, payload) =>
        {
            const defaultEntity = getDefaultMetaEntity(state, payload.id);
            defaultEntity.needUpdate = payload.needUpdate;
            defaultEntity.id = payload.id;

            return {
                ...state,
                ...{
                    [payload.id]: defaultEntity,
                },
            };
        },

        [ACTIONS.BATCH_LOADING]: (state, payload) =>
        {
            const entities = payload.ids.map((id) =>
            {
                const entity = getDefaultMetaEntity(state, id);
                entity.loading = payload.status;
                entity.id = id;

                if (payload.status)
                {
                    entity.error = '';
                    entity.includes = payload.includes;
                }
                else
                {
                    entity.includes = null;
                }

                return entity;
            });

            return {
                ...state,
                ...entities,
            };
        },

        [ACTIONS.ERROR]: (state, payload) =>
        {
            const defaultEntity = getDefaultMetaEntity(state, payload.id);
            defaultEntity.error = payload.error;
            defaultEntity.loading = false;
            defaultEntity.includes = null;
            defaultEntity.id = payload.id;

            return {
                ...state,
                ...{
                    [payload.id]: defaultEntity,
                },
            };
        },

        [ACTIONS.BATCH_ERROR]: (state, payload) =>
        {
            const entities = payload.ids.map((id) =>
            {
                const entity = getDefaultMetaEntity(state, id);
                entity.error = payload.error;
                entity.loading = false;
                entity.includes = null;
                entity.id = id;

                return entity;
            });

            return {
                ...state,
                ...entities,
            };
        },

        [ACTIONS.SET_LOADED_INCLUDES]: (state, payload) =>
        {
            const defaultEntity = getDefaultMetaEntity(state, payload.id);
            defaultEntity.loadedIncludes = uniq(union(defaultEntity.loadedIncludes, payload.includes));
            return {
                ...state,
                ...{
                    [payload.id]: defaultEntity,
                },
            };
        },
        [ACTIONS.FILTER]: (state, payload) =>
        {
            const defaultEntity = getDefaultMetaEntity(state, payload.id);
            defaultEntity.filters = payload.filters;

            return {
                ...state,
                ...{
                    [payload.id]: defaultEntity,
                },
            };
        },
        [ACTIONS.PAGINATE]: (state, payload) =>
        {
            const defaultEntity = getDefaultMetaEntity(state, payload.id);
            if (!defaultEntity.pagination[payload.cursor.current])
            {
                defaultEntity.pagination[payload.cursor.current] = [];
            }

            defaultEntity.pagination[payload.cursor.current].push(payload);

            return {
                ...state,
                ...{
                    [payload.id]: defaultEntity,
                },
            };
        },
    };
}

function getDefaultMetaEntity(state, id)
{
    let response = null;

    if (has(state, id)) response = { ...state[id] };
    else
    {
        response = {
            id: null, loading: false, includes: null, error: '', loadedIncludes: [], needUpdate: false, filters: null, pagination: {},
        };
    }

    return response;
}
